import React, { useState } from "react";
import { useAppContext } from "../../AppProvider";
import { useShipmentOverviewContext } from "./providers/Overview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { useTypes } from "../../utilities/types";
import ZPLViewer from "../../Components/common/ZPLViewer";
import { Checkbox } from "../../Components/Checkboxs/Checkbox/Checkbox";

const Overview: React.FC = () => {
  const [ddtEnabled, setDdtEnabled] = useState(true);
  const { dictionary } = useAppContext();
  const { data, loader } = useShipmentOverviewContext();
  const { currencies } = useTypes();

  const currency =
    currencies.find((c) => c.value === data.shipment?.goodsValueCurrency) ||
    null;
  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <div
            className="d-grid grid-column align-items-center"
            style={{ gridTemplateColumns: "auto" }}
          >
            <div>
              <label className="label-2">
                {dictionary.references.carrier_reference}:
              </label>
              <label className="label-3">
                {data.shipment?.carrierReference || "-"}
              </label>
            </div>
            <div className="text-end">
              <label className="label-2">{dictionary.words.price}:</label>
              <label className="label-3 fs-1">
                {`${data.shipment?.ratingCost?.toFixed(2)} ${
                  currency?.label
                }` || "-"}
              </label>
            </div>
          </div>
          <div className="mt-2 text-center">
            {data.attachments?.[0].type?.format === "ZPL" ? (
              <>
                <div className="row mb-2">
                  <div className="col text-end">
                    <Checkbox
                      name="ddtEnabled"
                      checked={ddtEnabled}
                      onChange={() => {
                        setDdtEnabled(!ddtEnabled);
                      }}
                      label="Aggiungi DDT in etichetta"
                    />
                  </div>
                </div>
                <ZPLViewer
                  url={data.attachments?.[0].url || ""}
                  reference={data.shipment?.internalReference}
                  shipmentId={data.shipment?.id || ""}
                  ddtEnabled={ddtEnabled}
                />
              </>
            ) : (
              <iframe
                src={data.attachments?.[0].url}
                style={{ width: "100%", height: "500px" }}
              ></iframe>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Overview;
